import { fonts, fontSize } from "config/styles/fonts";
import { IAccentColors } from "config/types";

const styles = {
  contentWrap: {
    display: "flex",
    flexDirection: "column",
    gap: "20px",
    height: "100%",
    "& .MuiTypography-root": {
      fontSize: fontSize.xxl,
      lineHeight: 1,
    },
    p: {
      xs: "20px 16px",
      md: "20px 36px",
    },
  },
  subtitle: {
    mt: "-10px",
    "&.MuiTypography-root": {
      fontSize: fontSize.l,
      textTransform: "lowercase",
    },
  },
  skeleton: {
    width: "80%",
  },
  carWrap: {
    display: "flex",
    justifyContent: "space-between",
    "& .MuiButtonBase-root.MuiIconButton-root": {
      display: "flex",
      border: "2px solid",
      borderColor: "green.main",
      "&:hover": {
        opacity: 0.8,
        backgroundColor: "inherit",
      },
    },
  },
  carInfoWrap: (accentColor: IAccentColors) => ({
    display: "flex",
    alignItems: "center",
    gap: "20px",
    "& .MuiTypography-root": {
      fontSize: fontSize.s,
    },
    "& svg": {
      width: "50px",
      color: accentColor.main,
    },
  }),
  carInfo: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  stepper: {
    maxHeight: {
      xs: "214px",
      xl: "unset",
    },
    overflowY: {
      xs: "auto",
      xl: "unset",
    },
    "& .MuiStepConnector-line": {
      minHeight: {
        xs: "10px",
        xxl: "20px",
      },
    },
    "& .MuiStepLabel-root": {
      p: "6px 0",
    },
  },
  stepLabel: {
    "& .MuiStepLabel-labelContainer": {
      color: "text.primary",
      "& .MuiStepLabel-label": {
        fontFamily: fonts.text,
      },
    },
  },
  timeWrap: {
    display: "flex",
    gap: "10px",
    "& .MuiTypography-root": {
      fontSize: fontSize.l,
      letterSpacing: "1px",
    },
  },
  time: {
    color: "text.secondary",
  },
  footer: (orderId: boolean) => ({
    mt: orderId ? "auto" : "unset",
    display: "flex",
    gap: "30px",
    "& > .MuiBox-root > .MuiBox-root > .MuiTypography-root:first-of-type": {
      fontSize: fontSize.xxxl,
    },
  }),
  btn: {
    height: "56px",
    fontSize: fontSize.l,
    borderRadius: "50px",
  },
};

export default styles;
